import moment from 'moment';
import { I18n } from '@aws-amplify/core';

import { COMPARISON_TYPE } from '@/views/Bera/constants';

import type { Moment } from 'moment';
import type { BeraJobSummaryListFilter } from '@/types/Bera';
import type { FieldOption, BeraFilterFormFields } from '@/views/Bera/types';

type NamedEntity = {
	id: string;
	name: string;
};

export function toFilterQuery(values: BeraFilterFormFields): BeraJobSummaryListFilter {
	const query: BeraJobSummaryListFilter = {
		company_id_filter: values.company_id_filter,
		sector_id: values.sector_id,
		line_id: values.line_id,
		workstation_id: values.workstation_id,
		cycle_id: values.cycle_id,
		task_id: values.task_id,
		report_name: values.report_name,
		type_overall_score: values.type_overall_score,
		min_overall_score: values.min_overall_score,
		max_overall_score: values.max_overall_score,
		type_rpn: values.type_rpn,
		min_rpn: values.min_rpn,
		max_rpn: values.max_rpn
	};

	if (values.created_at) {
		const [start, end] = values.created_at;
		query.created_at_start = start.format();
		query.created_at_end = end.format();
	}

	if (values.updated_at) {
		const [start, end] = values.updated_at;
		query.updated_at_start = start.format();
		query.updated_at_end = end.format();
	}

	return query;
}

export function toSearchParams(query: BeraJobSummaryListFilter): string {
	const searchParams = new URLSearchParams();

	Object.entries(query).forEach(([key, value]) => {
		if (value) {
			searchParams.set(key, value);
		}
	});

	return searchParams.toString();
}

export function toInitialValues(query: BeraJobSummaryListFilter): BeraFilterFormFields {
	const { created_at_start, created_at_end, updated_at_start, updated_at_end, ...fields } = query;

	const initialValues: BeraFilterFormFields = { ...fields };

	if (created_at_start && created_at_end) {
		initialValues.created_at = [moment(created_at_start), moment(created_at_end)];
	}

	if (updated_at_start && updated_at_end) {
		initialValues.updated_at = [moment(updated_at_start), moment(updated_at_end)];
	}

	return initialValues;
}

export function toOptions(items: NamedEntity[] = []): FieldOption[] {
	const options = items.map(({ id, name }) => ({ value: id, label: name }));

	return options;
}

export function isFutureDate(currentDate: Moment): boolean {
	const isFuture = !!currentDate && currentDate.valueOf() >= Date.now();

	return isFuture;
}

export function getComparisonOptions(): FieldOption[] {
	const options = [
		{ value: COMPARISON_TYPE.GREATER, label: I18n.get('Greater than') },
		{ value: COMPARISON_TYPE.GREATER_OR_EQUAL, label: I18n.get('Greater than or equal') },
		{ value: COMPARISON_TYPE.LESS, label: I18n.get('Less than') },
		{ value: COMPARISON_TYPE.LESS_OR_EQUAL, label: I18n.get('Less than or equal') },
		{ value: COMPARISON_TYPE.BETWEEN, label: I18n.get('Between') }
	];

	return options;
}
